import { useFormatMessage } from '../../../intl/intl';

export function useOrderDetailWhimLang() {
  return {
    title: useFormatMessage({ id: 'orderDetailWhim.title' }),
    delete: useFormatMessage({ id: 'orderDetailWhim.deleteBtn' }),
  };
}
